<template>
 <div class="wrapper" id='container1'>  
  <CButton  color="info" @click="openCamera"><b>Scan QRCode</b></CButton>
  <CRow class="mt-3">
    <CCol >


<div id="div-id" ref="div-id">
      <CCard>
        
        <CCardBody>
          
          <div class="row">
            
              <div class="col-md-12">
                <h4 class="font-xl mb-3 " >Detail Participant </h4>
                  <div class="card">
                    
                      <div class="card-body">
                        
                          <Datatable 
                              :items="items" 
                              :fields="fields" 
                              :meta="meta" 
                              @per_page="handlePerPage" 
                              @pagination="handlePagination" 
                              @search="handleSearch" 
                              @sort="handleSort"
                              @is_active="handleIsActive"
                              :btn_show="true"
                              :btn_paid="true"
                              :btn_edit="true"
                              :btn_deactivate="true"
                              :btn_reactivate="false"
                              :btn_delete="false"
                              @show="handleShow"
                              @edit_att="handleEditAtt"
                              @attendance="handleAttendance"
                              @resendmail="handleResendmail"
                              @paid="handlePaid"
                              @editEvent="handleEditEvent"
                              @changeToPublish="handlechangeToPublish"
                              @showRegistrationPage="handleShowRegistrationPage"
                              @deactivate="handleDeactivate"
                              @reactivate="handleReactivate"
                          />
                      </div>
                  </div>
              </div>
          </div>           
        </CCardBody>
       
      </CCard>
       </div>
    </CCol>   
  </CRow>


  
<!-- {{ items }} -->
<!-- <pre>{{ $data | json }}</pre> -->

            
    <alertmodal></alertmodal>
    
  </div>
</template>

<script>
import Datatable from '@/components/datatables_event_order.vue'

import alertmodal from '@/views/alert/modal.vue';
import event from '@/services/event'
import EventBus from '@/eventBus';
import store from '@/store.js'

export default {
  name: 'Dashboard',
  components: {
    Datatable,
    alertmodal
  },
  data () {
    return {
      mode:'',
      cardCollapse: true,
      datas:[],
      fields: [
          {key: 'booking_id', sortable: false, },
          {key: 'name', sortable: false, },
          {key: 'email', sortable: false},
          //{key: 'total', sortable: false},
          {key: 'payment_status', sortable: false},
          {key: 'order_status', sortable: false},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      payment: [],
      meta: [],
      current_page: 1,
      per_page: 25,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
    }
  },



  mounted(){
    this.loadData()

    EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });

    

  },

  methods: {
     loadData(){
      let current_page = this.search == '' ? this.current_page:1
      var params = {
       
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }


        event.getEventbyID_withorder(this.$route.query.id, params)
        .then(res => {
            this.datas = res; 

          let getData = res.orders
          this.items = getData.data
          this.payment = JSON.parse(res.data.payment_information)
          //this.items = res.data.event_order
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }

        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        
    },
    openShowOrderDetail(id){
      let route = this.$router.resolve(
        {
        path: '/event-order-detail',
        query: {'id': id}
        });
      window.open(route.href, '_blank', "height=800,width=1000");  
    },
    openShowOrderAttendance(id){
      let route = this.$router.resolve(
        {
        path: '/event-order-attendance',
        query: {'id': id, 'mode': 'create'}
        });
      window.open(route.href, '_blank', "height=800,width=1000");  
    },
    openShowOrderAttendanceEdit(id){
      let route = this.$router.resolve(
        {
        path: '/event-order-attendance',
        query: {'id': id, 'mode': 'edit'}
        });
      window.open(route.href, '_blank', "height=800,width=1000");  
    },
    resendMail(id){
      if(confirm("Do you really want to resend mail?")){
        event.resendMailAttendance(id)
        .then(res => {
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      } 
    },
    openCamera: function () {
      //this.$router.push({name:'Event Camera', query: {id:this.$route.query.id} }) 
      this.$router.push({name:'Event Scan', query: {id:this.$route.query.id} }) 
    },

    setAsPaid(id){
      if(confirm("Do you really want to set as PAID?")){
        event.setAsPaid(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }  
    },
      
    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShowOrderDetail(val) 
    }, 
    handleEditAtt(val) {
        this.openShowOrderAttendanceEdit(val) 
    }, 
    handleAttendance(val) {
        this.openShowOrderAttendance(val) 
    }, 
    handleResendmail(val) {
        this.resendMail(val) 
    }, 
    handlePaid(val) {
        this.setAsPaid(val) 
    }, 
    handleEditEvent(val) {
        this.openEditEvent(val) 
    }, 
    handleShowRegistrationPage(val) {
        this.showRegistrationPage(val) 
    },    
    handlechangeToPublish(val) {
        this.changeToPublish(val) 
    },    
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },   

    avail(x){
      if(x == 'a'){x = 'Private'}
      else if(x == 'b'){x = 'ICare Coach'}
      else if(x == 'c'){x = 'ICL and Core Team'}
      else if(x == 'd'){x = 'Head of Department'}
      else if(x == 'e'){x = 'Volunter and Covenant'}
      else if(x == 'f'){x = 'Youth'}
      else if(x == 'g'){x = 'Everyone'}
      else{ x = '-' }
      return x
    },
  
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      //window.scrollTo(0, top);

      window.scrollTo({
        top: top,
        left: 0,
        behavior: 'smooth'
      });

    }

  }
}
</script>
